import DragDropContext, {
  DragDropContextProvider as DragDropProvider,
} from './DragDropContext';

const DragDropContextProvider = DragDropProvider;

export { DragDropContext as default, DragDropContextProvider };
